import React from 'react';
import { InputLabel as MuiInputLabel } from '@material-ui/core';
import { PopoverTooltip } from '../tooltip/tooltip';
import HelpIcon from '@material-ui/icons/Help';
import useInputLabelStyles from './input-label.styles';

interface InputLabelProps {
  fieldName: string;
  fieldDescription?: string;
  fieldExternalLinkText?: string;
  fieldExternalLinkUrl?: string;
  isRequired?: boolean;
  hasError?: boolean;
}

const InputLabel: React.FC<InputLabelProps> = ({
  fieldName,
  fieldDescription,
  fieldExternalLinkText,
  fieldExternalLinkUrl,
  isRequired,
  hasError
}): JSX.Element => {
  const classes = useInputLabelStyles();

  return (
    <MuiInputLabel className={classes.root}>
      <span className={hasError ? classes.errorLabel : ''}>{fieldName}</span>
      { isRequired && <span className={classes.requiredAsterisk}>*</span> }
      {fieldExternalLinkText && fieldExternalLinkUrl && (
        <a 
          href={fieldExternalLinkUrl} 
          target="_blank" rel="noopener noreferrer"
        >
          {fieldExternalLinkText}
        </a>
      )}

      {fieldDescription && (
        <PopoverTooltip messageDescription={fieldDescription}>
          <HelpIcon />
        </PopoverTooltip>
      )}
    </MuiInputLabel>
  );
};

export default InputLabel;